<template>
  <!-- eslint-disable -->
  <div class="login-container">
    <!-- Left Panel -->
    <div class="left-panel">
      <div class="brand-section">
        <div class="gradient-overlay"
          :style="{ 'background': 'linear-gradient(135deg, ' + prestador.admin.assets.colors.primary + ', ' + prestador.admin.assets.colors.secondary + ')' }">
        </div>
        <div class="brand-content">
          <div class="logo-container">
            <img class="brand-logo"
              :src="'https://assets-prestador-clinicgo.s3.sa-east-1.amazonaws.com/' + prestador.id + '/images/logo.png'"
              alt="Logo" />
          </div>
          <div class="brand-text">
            <h1 class="brand-title">Clinic Go SaaS</h1>
            <p class="brand-subtitle">Software integral de Gestión de Servicios de Salud a Domicilio</p>
          </div>
          <div class="medical-icons">
            <div class="medical-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12 21.35L10.55 20.03C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5C22 12.27 18.6 15.36 13.45 20.03L12 21.35Z"
                  fill="rgba(255,255,255,0.8)" />
              </svg>
            </div>
            <div class="medical-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM17 12H13V16H11V12H7V10H11V6H13V10H17V12Z"
                  fill="rgba(255,255,255,0.8)" />
              </svg>
            </div>
            <div class="medical-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z"
                  fill="rgba(255,255,255,0.8)" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Panel -->
    <div class="right-panel">
      <div class="login-form-container">
        <form v-if="!cargando" class="login-form" action="javascript:void(0);" method="get">
          <!-- Mobile Logo -->
          <div class="mobile-logo">
            <img class="mobile-logo-img"
              :src="'https://assets-prestador-clinicgo.s3.sa-east-1.amazonaws.com/' + prestador.id + '/images/logo.png'"
              alt="Logo" />
          </div>

          <!-- Welcome Section -->
          <!-- Welcome Section -->
          <div class="welcome-section">
            <div class="welcome-icon">
              <svg width="32" height="32" viewBox="0 0 419 419" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0 0 C1.15739182 -0.01429047 1.15739182 -0.01429047 2.33816528 -0.02886963 C3.96351695 -0.04098395 5.58900987 -0.04024588 7.21435547 -0.02734375 C9.68320565 -0.01568219 12.14518002 -0.06788854 14.61328125 -0.125 C27.7726158 -0.23717191 27.7726158 -0.23717191 32.7734375 4 C34.49365234 5.92089844 34.49365234 5.92089844 35.8203125 7.734375 C36.71363281 8.92546875 36.71363281 8.92546875 37.625 10.140625 C43.65670676 21.93987618 43.26656742 31.35186504 41.16796875 44.14160156 C40.99240448 45.24679138 40.81684021 46.3519812 40.63595581 47.49066162 C40.05794191 51.11982413 39.47028341 54.7473575 38.8828125 58.375 C38.47852934 60.9059522 38.07497579 63.43702104 37.67211914 65.96820068 C36.72074348 71.93740689 35.76374311 77.90568104 34.80342579 83.8734529 C32.98054307 95.2015447 31.16652951 106.53104077 29.35958862 117.86168671 C28.76486105 121.58092065 28.16500699 125.29930269 27.56469727 129.01763916 C27.20049626 131.29330499 26.83647293 133.56899926 26.47265625 135.84472656 C26.22018631 137.39552917 26.22018631 137.39552917 25.96261597 138.97766113 C25.73543381 140.4072818 25.73543381 140.4072818 25.50366211 141.86578369 C25.37092392 142.69016056 25.23818573 143.51453743 25.10142517 144.36389542 C24.80750755 146.84235263 24.77181156 149.24091299 24.8203125 151.734375 C25.94824219 151.28707031 27.07617188 150.83976563 28.23828125 150.37890625 C40.22903135 145.73037908 52.20823085 142.2474452 64.8203125 139.734375 C66.06039062 139.486875 67.30046875 139.239375 68.578125 138.984375 C101.90058825 133.71136983 139.06569681 137.14116219 167.43359375 156.51953125 C169.63386641 158.18778634 171.72816109 159.93313226 173.8203125 161.734375 C174.58988281 162.33765625 175.35945313 162.9409375 176.15234375 163.5625 C182.77822043 168.96868794 188.33289868 176.0817849 189.8203125 184.734375 C190.70143117 196.88225694 189.70318415 206.5718623 181.5703125 216.109375 C173.41128679 224.5217038 164.71199909 228.78650317 152.9453125 229.171875 C142.12295106 228.89228762 133.58294774 225.30368791 125.8203125 217.734375 C124.66501644 216.25758253 123.53979041 214.75678858 122.4453125 213.234375 C116.71741279 205.46458511 108.07628764 201.00470852 98.8203125 198.734375 C98.09585937 198.55132812 97.37140625 198.36828125 96.625 198.1796875 C77.22033498 195.09872397 58.67967592 199.72320013 42.6875 210.9296875 C39.68710036 213.30026564 36.81283089 215.68500592 34.18359375 218.46484375 C32.8203125 219.734375 32.8203125 219.734375 30.8203125 219.734375 C30.56507813 220.30414063 30.30984375 220.87390625 30.046875 221.4609375 C28.68256895 223.98968311 27.06421505 225.92774772 25.1953125 228.109375 C7.00095777 250.6215929 -0.67203973 280.14353443 1.8203125 308.734375 C3.88007612 325.68243002 11.03081053 340.65860267 24.23046875 351.76171875 C37.79311858 361.92833265 54.14293757 363.95070984 70.5703125 362.046875 C86.63415811 359.58617805 101.64480359 352.03710371 111.83203125 339.19921875 C116.59502993 332.18386928 119.27668756 324.76379013 121.8203125 316.734375 C121.18528809 316.75008545 120.55026367 316.7657959 119.89599609 316.78198242 C116.9958602 316.8446609 114.09586726 316.88346917 111.1953125 316.921875 C109.69677734 316.95958008 109.69677734 316.95958008 108.16796875 316.99804688 C101.02033202 317.06904989 96.63224771 316.219341 91.1328125 311.359375 C86.20468495 305.76528427 84.65755352 301.17788568 84.8203125 293.734375 C86.32290896 284.19361689 91.42713619 275.96840699 98.984375 270.01171875 C109.80792601 262.48129071 121.80000999 262.42939338 134.61328125 262.46875 C136.01329109 262.46739868 137.41330046 262.46545428 138.81330872 262.46295166 C141.72706635 262.46002526 144.64070025 262.46421904 147.55444336 262.47363281 C151.26956304 262.48505799 154.98439461 262.47843284 158.6995039 262.46648788 C161.58301428 262.45922888 164.46645735 262.46157512 167.34996986 262.46674347 C168.71936389 262.46806716 170.08876424 262.46647773 171.45815086 262.46178436 C191.27884884 262.40870806 191.27884884 262.40870806 198.8203125 268.734375 C204.5810215 275.77956641 206.57566668 281.71141985 205.8203125 290.734375 C205.07359157 294.55928487 204.01257246 298.25653217 202.8828125 301.984375 C202.57069824 303.02779053 202.25858398 304.07120605 201.93701172 305.14624023 C193.6211161 332.08215619 180.25638464 354.38594101 160.8203125 374.734375 C159.60021484 376.03375 159.60021484 376.03375 158.35546875 377.359375 C132.18230776 404.50819677 93.83798162 419.08579725 56.41015625 419.90234375 C23.88139085 420.16490266 -8.7374541 414.51552199 -34.1796875 392.734375 C-35.41138672 391.70183594 -35.41138672 391.70183594 -36.66796875 390.6484375 C-42.61419909 385.50526407 -47.47780067 380.01757619 -52.1796875 373.734375 C-53.10543949 372.50128012 -54.0312229 371.26820882 -54.95703125 370.03515625 C-56.49031529 367.99019371 -58.02216329 365.94420538 -59.55078125 363.89575195 C-63.70278575 358.33920218 -67.9610368 352.87535115 -72.26171875 347.43359375 C-80.44893582 337.07292949 -88.51375487 326.61499777 -96.5546875 316.140625 C-99.74596725 311.99196132 -102.9639005 307.86405019 -106.1796875 303.734375 C-110.19434375 298.57880148 -114.20069773 293.41753272 -118.1796875 288.234375 C-132.9804596 268.95524162 -132.9804596 268.95524162 -148.234375 250.03515625 C-173.01137463 219.97567714 -173.01137463 219.97567714 -171.1796875 199.734375 C-168.89010389 191.14843646 -162.56889644 182.78575149 -154.9921875 178.171875 C-144.99999859 172.73186262 -135.98511281 171.56683053 -124.96875 174.7265625 C-113.8162422 178.75646028 -107.2199063 187.42595523 -100.40234375 196.7109375 C-97.40890836 200.78285138 -94.29641839 204.7567467 -91.1796875 208.734375 C-93.52399207 198.72975616 -96.46741352 188.94350383 -99.4765625 179.125 C-99.99389447 177.42853887 -100.51091677 175.73198328 -101.02764893 174.03533936 C-102.38361014 169.58542404 -103.74288239 165.13652798 -105.10314941 160.68792725 C-106.46329973 156.23896416 -107.82170663 151.78946945 -109.1796875 147.33984375 C-109.44430031 146.47282585 -109.70891312 145.60580795 -109.98154449 144.71251678 C-112.03847636 137.97000419 -114.08806479 131.22527941 -116.13204193 124.47882843 C-117.20786097 120.9292323 -118.28648243 117.38063143 -119.37915039 113.83618164 C-120.39092185 110.55013079 -121.38885078 107.26022218 -122.3828125 103.96875 C-122.66131042 103.07907532 -122.93980835 102.18940063 -123.22674561 101.27276611 C-126.32167848 90.89116232 -127.70903491 80.2327918 -122.98828125 70.203125 C-117.88862069 60.97649119 -110.48138453 54.35969799 -100.3515625 51.15625 C-89.24606521 48.99906707 -79.56523752 51.08216873 -70.08984375 57.05078125 C-61.22460624 63.85974923 -57.86467395 74.67875791 -54.8671875 84.984375 C-54.29626456 86.8820282 -53.72533989 88.77968088 -53.15432739 90.67730713 C-52.3575607 93.33804882 -51.5736882 96.00252423 -50.78948975 98.66699219 C-49.33652786 103.59289799 -47.8621747 108.51245906 -46.38989258 113.43261719 C-45.59072971 116.10339735 -44.79812481 118.7759917 -44.01049805 121.45019531 C-43.65383057 122.65256836 -43.29716309 123.85494141 -42.9296875 125.09375 C-42.61515625 126.16077148 -42.300625 127.22779297 -41.9765625 128.32714844 C-41.40444954 130.65930111 -41.40444954 130.65930111 -40.1796875 131.734375 C-40.05241539 130.91329726 -40.05241539 130.91329726 -39.92257214 130.0756321 C-37.85164218 116.71853818 -35.77279525 103.3626969 -33.68554974 90.00814247 C-32.67638471 83.54978125 -31.66980242 77.09103986 -30.66918945 70.63134766 C-29.70274327 64.39286313 -28.72942558 58.15548555 -27.75141335 51.91880417 C-27.38020719 49.54386612 -27.01144324 47.16854497 -26.64520836 44.79283524 C-26.13028 41.45539487 -25.60654131 38.11944479 -25.08081055 34.78369141 C-24.93263382 33.8097644 -24.78445709 32.8358374 -24.63179016 31.83239746 C-22.68175 19.6089164 -19.82880939 9.94327957 -9.957901 1.83003235 C-6.84823987 -0.08600477 -3.53825952 -0.01861088 0 0 Z"
                  :fill="prestador.admin.assets.colors.primary" transform="translate(191.1796875,-0.734375)" />
              </svg>
            </div>
            <h1 class="welcome-title">
              ¡Bienvenido al panel de
              <span class="brand-name" :style="{ 'color': prestador.admin.assets.colors.primary }">{{ prestador.nombre
                }}</span>!
              <span class="wave-emoji">👋</span>
            </h1>
            <p class="welcome-subtitle">Por favor inicia sesión para comenzar a gestionar tus servicios médicos.</p>
          </div>

          <!-- Login Fields -->
          <div v-if="!show2FA" class="form-fields">
            <div class="input-group">
              <label class="input-label">Usuario o correo electrónico</label>
              <div class="input-wrapper">
                <div class="input-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"
                      fill="#9ca3af" />
                  </svg>
                </div>
                <input id="login-email" v-model="login_correo_electronico" type="text" class="form-input"
                  placeholder="Escribe tu usuario o correo" />
              </div>
            </div>

            <div class="input-group">
              <div class="password-header">
                <label class="input-label">Contraseña</label>
                <!-- <button type="button" class="forgot-password"
                  :style="{ 'color': prestador.admin.assets.colors.primary }">
                  ¿Olvidaste tu contraseña?
                </button> -->
              </div>
              <div class="input-wrapper">
                <div class="input-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM12 19C10.9 19 10 18.1 10 17C10 15.9 10.9 15 12 15C13.1 15 14 15.9 14 17C14 18.1 13.1 19 12 19ZM15.1 8H8.9V6C8.9 4.29 10.29 2.9 12 2.9C13.71 2.9 15.1 4.29 15.1 6V8Z"
                      fill="#9ca3af" />
                  </svg>
                </div>
                <input id="login-password" v-model="login_password" type="password" class="form-input"
                  placeholder="*********" />
              </div>
            </div>
          </div>

          <!-- 2FA Field -->
          <div v-if="show2FA" class="form-fields">
            <div class="input-group">
              <label class="input-label">Código de autenticación 2FA</label>
              <div class="input-wrapper">
                <div class="input-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM10 17L6 13L7.41 11.59L10 14.17L16.59 7.58L18 9L10 17Z"
                      fill="#9ca3af" />
                  </svg>
                </div>
                <input id="two-fa-code" v-model="two_fa_code" type="text" class="form-input"
                  placeholder="Ingrese el código 2FA" />
              </div>
              <div class="twofa-help">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z"
                    fill="#64748b" />
                </svg>
                <span>Ingresa el código de 6 dígitos de tu aplicación de autenticación</span>
              </div>
            </div>
          </div>

          <!-- Message show2FA -->
          <div v-if="show2FA === true && error_msg_login != ''" class="error-section">
            <div class="twofa-message">
              <div class="error-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L3 6v6c0 5.25 3.75 10 9 11 5.25-1 9-5.75 9-11V6l-9-4z" stroke="#17a2b8" stroke-width="2"
                    fill="none" />
                  <path d="M12 11a2 2 0 100 4 2 2 0 000-4z" fill="#17a2b8" />
                </svg>
              </div>

              <span class="twofa-text">{{ error_msg_login }}</span>
            </div>
          </div>

          <!-- Mensaje de error general -->
          <div v-else-if="error_msg_login != ''" class="error-section">
            <div class="error-message">
              <div class="error-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z" fill="#ef4444" />
                </svg>
              </div>
              <span class="error-text">{{ error_msg_login }}</span>
            </div>
          </div>


          <!-- Login Button -->
          <button type="submit" class="login-button"
            :style="{ 'background': 'linear-gradient(135deg, ' + prestador.admin.assets.colors.primary + ', ' + prestador.admin.assets.colors.secondary + ')' }"
            @click="entrar()">
            <span v-if="!cargando" class="button-content">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10 17L15 12L10 7V10H4V14H10V17ZM20 3H12C10.9 3 10 3.9 10 5V9H12V5H20V19H12V15H10V19C10 20.1 10.9 21 12 21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3Z"
                  fill="currentColor" />
              </svg>
              Ingresar al Sistema
            </span>
            <div v-if="cargando" class="loading-content">
              <div class="loading-spinner"></div>
              <span>Verificando credenciales...</span>
            </div>
          </button>

          <!-- Security Notice -->
          <div class="security-notice">
            <div class="security-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1Z" fill="#10b981" />
              </svg>
            </div>
            <span>Conexión segura y cifrada para proteger tu información médica</span>
          </div>
        </form>

        <!-- Loading State -->
        <div v-else class="loading-container">
          <Loader :width="100" :height="100" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';

/* Core CSS */
import '@/assets/estilo_importado/vendor/css/rtl/core.css';
import '@/assets/estilo_importado/vendor/css/rtl/theme-default.css';
import '@/assets/estilo_importado/css/demo.css';

/* Vendor css */
import '@/assets/estilo_importado/vendor/libs/node-waves/node-waves.css';
import '@/assets/estilo_importado/vendor/libs/perfect-scrollbar/perfect-scrollbar.css';
import '@/assets/estilo_importado/vendor/libs/typeahead-js/typeahead.css';

import '@/assets/estilo_importado/vendor/css/pages/page-auth.css';
import '@/assets/estilo_importado/vendor/libs/@form-validation/umd/styles/index.min.css';

/* Icons */
import '@/assets/estilo_importado/vendor/fonts/fontawesome.css';
import '@/assets/estilo_importado/vendor/fonts/tabler-icons.css';
import Loader from '@/components/Loader.vue';

export default {
  name: 'HelloWorld',
  components: {
    Loader,
  },
  data() {
    return {
      login_correo_electronico: '',
      login_password: '',
      two_fa_code: '',
      cargando: false,
      error_msg_login: '',
      show2FA: false,
    };
  },
  created() { },
  computed: {
    ...mapGetters(['admin_datos', 'isLoggedIn', 'prestador']),
  },
  methods: {
    ...mapActions(['loginAdmin', 'getNotificaciones']),
    entrar() {
    this.cargando = true;
    this.error_msg_login = '';
    const payload = {
      email: this.login_correo_electronico,
      password: this.login_password,
      prestador_id: this.prestador.id,
    };

    if (this.show2FA) {
      payload['2fa_code'] = this.two_fa_code;
    }

    this.loginAdmin(payload)
      .then((resp) => {
        this.cargando = false;
        if (resp.data && resp.data.token) {
          
          this.$router.push(`/Inicio`);
          this.getNotificaciones();
        } else {
          this.show2FA = true;
          this.error_msg_login = 'Se ha enviado un código 2FA a su WhatsApp.';
        }
      })
      .catch((err) => {
        this.cargando = false;
        if (err.response && err.response.status === 200 && this.show2FA === false) {
          this.show2FA = true;
          this.error_msg_login = 'Se ha enviado un código 2FA a su WhatsApp.';
        } else if (err.response && err.response.data) {
          this.error_msg_login = 'Usuario o contraseña incorrectos';
        } else {
          this.error_msg_login = 'Error al iniciar sesión.';
        }
      });
  },  
  },
};
</script>


<style scoped>
/* Base Styles */
* {
  box-sizing: border-box;
}

/* Main Container */
.login-container {
  display: flex;
  min-height: 100vh;
  background-color: #fafbfc;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

/* Left Panel */
.left-panel {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  position: relative;
  overflow: hidden;
}

.brand-section {
  position: relative;
  width: 100%;
  max-width: 500px;
  height: 600px;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}

.gradient-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.95;
}

.brand-content {
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 40px;
  text-align: center;
  color: white;
}

.logo-container {
  margin-bottom: 40px;
}

.brand-logo {
  max-width: 120px;
  max-height: 120px;
  width: auto;
  height: auto;
  filter: brightness(0) invert(1);
  drop-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.brand-text {
  margin-bottom: 40px;
}

.brand-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0 0 16px 0;
  line-height: 1.2;
  color: white;
  -webkit-text-stroke: 1px #4b4a54;
  /* borde negro */
  text-shadow: 0 2px 4px #303030(0, 0, 0, 0.3);
  /* sombra opcional */
}

.brand-subtitle {
  font-size: 1.125rem;
  opacity: 0.9;
  margin: 0;
  line-height: 1.6;
}

.medical-icons {
  display: flex;
  gap: 24px;
  justify-content: center;
}

.medical-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.medical-icon:hover {
  transform: translateY(-4px);
  background: rgba(255, 255, 255, 0.2);
}

/* Right Panel */
.right-panel {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background-color: #ffffff;
}

.login-form-container {
  width: 100%;
  max-width: 480px;
}

.mobile-logo {
  display: none;
  text-align: center;
  margin-bottom: 32px;
}

.mobile-logo-img {
  max-width: 80px;
  max-height: 80px;
  width: auto;
  height: auto;
}

/* Welcome Section */
.welcome-section {
  text-align: center;
  margin-bottom: 40px;
}

.welcome-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, #eff6ff, #dbeafe);
  border-radius: 20px;
  margin-bottom: 24px;
}

.welcome-title {
  font-size: 1.875rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 16px 0;
  line-height: 1.3;
}

.brand-name {
  font-weight: 800;
}

.wave-emoji {
  font-size: 2rem;
  margin-left: 8px;
}

.welcome-subtitle {
  font-size: 1rem;
  color: #64748b;
  margin: 0;
  line-height: 1.6;
}

/* Form Fields */
.form-fields {
  margin-bottom: 32px;
}

.input-group {
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
}

.input-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
}

.password-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.forgot-password {
  background: none;
  border: none;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  transition: opacity 0.2s ease;
}

.forgot-password:hover {
  opacity: 0.8;
  text-decoration: underline;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 16px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.form-input {
  width: 100%;
  padding: 16px 16px 16px 52px;
  /* espacio para el icono */
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 1rem;
  background-color: #ffffff;
  transition: all 0.2s ease;
  color: #1f2937;
}

.form-input:focus {
  outline: none;
  border-color: #0ea5e9;
  box-shadow: 0 0 0 4px rgba(14, 165, 233, 0.1);
}

.form-input::placeholder {
  color: #9ca3af;
}

.twofa-help {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  padding: 12px 16px;
  background-color: #f8fafc;
  border-radius: 8px;
  font-size: 0.875rem;
  color: #64748b;
}

/* Error Section */
.error-section {
  margin-bottom: 24px;
}

.error-message {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background-color: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 12px;
}

.twofa-message {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background-color: #def6ef;
  border: 1px solid #17a2b8;
  border-radius: 12px;
}

.error-icon {
  flex-shrink: 0;
}

.error-text {
  font-size: 0.875rem;
  color: #dc2626;
  font-weight: 500;
}

.twofa-text {
  font-size: 0.875rem;
  color: #17a2b8;
  font-weight: 500;
}

/* Login Button */
.login-button {
  width: 100%;
  padding: 16px 24px;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 24px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.login-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.login-button:active {
  transform: translateY(0);
}

.button-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.loading-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* Security Notice */
.security-notice {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
  padding: 12px 16px;
  background-color: #f0fdf4;
  border-radius: 8px;
  font-size: 0.875rem;
  color: #166534;
}

.security-icon {
  flex-shrink: 0;
}

/* Loading Container */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .login-container {
    flex-direction: column;
  }

  .left-panel {
    flex: none;
    min-height: 300px;
    padding: 24px;
  }

  .brand-section {
    height: 250px;
    max-width: 100%;
  }

  .brand-content {
    padding: 40px 24px;
  }

  .brand-title {
    font-size: 1.875rem;
  }

  .brand-subtitle {
    font-size: 1rem;
  }

  .medical-icons {
    gap: 16px;
  }

  .medical-icon {
    width: 48px;
    height: 48px;
  }

  .right-panel {
    padding: 32px 24px;
  }
}

@media (max-width: 768px) {
  .left-panel {
    display: none;
  }

  .mobile-logo {
    display: block;
  }

  .right-panel {
    padding: 24px 20px;
  }

  .welcome-title {
    font-size: 1.5rem;
  }

  .welcome-subtitle {
    font-size: 0.875rem;
  }

  .form-input {
    padding: 14px 14px 14px 48px;
  }

  .login-button {
    padding: 14px 20px;
  }
}

@media (max-width: 480px) {
  .right-panel {
    padding: 20px 16px;
  }

  .welcome-section {
    margin-bottom: 32px;
  }

  .welcome-icon {
    width: 56px;
    height: 56px;
  }

  .welcome-title {
    font-size: 1.25rem;
  }

  .wave-emoji {
    font-size: 1.5rem;
    margin-left: 4px;
  }

  .form-fields {
    margin-bottom: 24px;
  }

  .input-group {
    margin-bottom: 20px;
  }

  .password-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .forgot-password {
    font-size: 0.8rem;
  }

  .form-input {
    padding: 12px 12px 12px 44px;
    font-size: 0.9rem;
  }

  .login-button {
    padding: 12px 16px;
    font-size: 0.9rem;
  }

  .twofa-help {
    padding: 10px 12px;
    font-size: 0.8rem;
  }

  .error-message {
    padding: 12px;
  }

  .error-text {
    font-size: 0.8rem;
  }

  .security-notice {
    padding: 10px 12px;
    font-size: 0.8rem;
  }
}

/* Animaciones suaves */
@media (prefers-reduced-motion: no-preference) {

  .medical-icon,
  .login-button,
  .form-input,
  .forgot-password {
    transition: all 0.2s ease;
  }
}

/* Modo oscuro (preparado para futuras implementaciones) */
@media (prefers-color-scheme: dark) {
  .login-container {
    background-color: #0f172a;
  }

  .right-panel {
    background-color: #1e293b;
  }

  .welcome-title {
    color: #f1f5f9;
  }

  .welcome-subtitle {
    color: #cbd5e1;
  }

  .input-label {
    color: #e2e8f0;
  }

  .form-input {
    background-color: #334155;
    border-color: #475569;
    color: #f1f5f9;
  }

  .form-input::placeholder {
    color: #94a3b8;
  }
}
</style>